import { render, staticRenderFns } from "./ToggleField.vue?vue&type=template&id=23c0aaa2&scoped=true&"
import script from "./ToggleField.vue?vue&type=script&lang=js&"
export * from "./ToggleField.vue?vue&type=script&lang=js&"
import style0 from "./ToggleField.vue?vue&type=style&index=0&id=23c0aaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0aaa2",
  null
  
)

export default component.exports